import { Button, ButtonBase, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

function SSIDSettings() {
  const auth = useAuth();

  const [
    isEditing,
    setIsEditing,
  ] = useState(false);
  const [
    taxAgentNumber,
    setTaxAgentNumber,
  ] = useState('123 456 789');

  const [
    emailSent,
    setEmailSent,
  ] = useState(false);

  const TextButton = styled(Button)(({ theme }) => ({
    color: 'white',
    textTransform: 'none',
    padding: '0vw 0vw',
  }));

  function sendEmailHandler() {
    // openLoading("Sending email ...")
    fetch(`${window.origin}/api/sendemail`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    }).then(response => response.status,
    ).then((status) => {
      console.log(status);
    });
    setEmailSent(true);
  }

  function naviagteATOPortal() {
    window.open('https://www.ato.gov.au/General/Online-services/Access-Manager/About-Access-Manager/#LogintoAccessManager', '_blank');
  }

  useEffect(() => {
    fetch(`${window.origin}/api/tan`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    }).then(response => response.json(),
    ).then((data) => {
      setTaxAgentNumber(data[0].tan);
    });
  }, []);

  return (
    <div>

      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Configure you access to Australian Tax Office
      </p>

      <div style={{ padding: '0 2.5vw' }}>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: 'rgb(254, 254, 255, 0.5)',
            padding: '1.5vw 1.5vw',
            borderRadius: '1vw',
            marginTop: '1.5vw',
            marginBottom: '1.5vw',
            color: 'rgb(0, 15, 30, 0.7)',
            // border: '1px rgb(254, 254, 255, 0.07) solid'
          }}
        >
          <div style={{ flex: 1 }}>
            <p style={{ marginTop: '0', fontSize: '1.2vw', marginBottom: '0.6vw' }}>Step 1</p>
            <p style={{ fontSize: '0.85vw', margin: 0, marginBottom: '0.6vw' }}>Click the Send Email button to receive your software service ID (SSID)</p>

          </div>
          <div style={{}}>
            <ButtonBase variant="text" style={{ color: 'rgb(255, 255, 255, 0.9)', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(rgb(50, 128, 128),rgb(50, 128, 128))', fontSize: '0.7vw', fontWeight: '600', cursor: 'pointer', padding: '0.5vw 1vw', backgroundColor: 'rgb(254, 254, 255, 0.05)', borderRadius: '0.4vw' }} onClick={sendEmailHandler}>
              { !emailSent && 'Send Email'}
              { emailSent && 'Resend Email'}
            </ButtonBase>
          </div>

        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: 'rgb(254, 254, 255, 0.5)',
            padding: '1.5vw 1.5vw',
            borderRadius: '1vw',
            marginTop: '1.5vw',
            marginBottom: '1.5vw',
            color: 'rgb(0, 15, 30, 0.7)',
            // border: '1px rgb(254, 254, 255, 0.07) solid'
          }}
        >
          <div style={{ flex: 1 }}>
            <p style={{ marginTop: '0', fontSize: '1.2vw', marginBottom: '0.6vw' }}>Step 2</p>
            <p style={{ fontSize: '0.85vw', margin: 0, marginBottom: '0.6vw' }}>Log in to Access Manager and update the SSID as provided to you via email</p>

          </div>
          <div style={{}}>
            <ButtonBase variant="text" style={{ color: 'rgb(255, 255, 255, 0.9)', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(rgb(50, 128, 128),rgb(50, 128, 128))', fontSize: '0.7vw', fontWeight: '600', cursor: 'pointer', padding: '0.5vw 1vw', backgroundColor: 'rgb(254, 254, 255, 0.05)', borderRadius: '0.4vw' }} onClick={naviagteATOPortal}>Go to ATO Portal</ButtonBase>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SSIDSettings;
